import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import FormattedMessage from '../FormattedMessage/FormattedMessage'

/* Microsoft partnerId = 8 */
const partnerId = 8

export default class MicrosoftIntegration extends Component {
  handleRedeemWithBrowser = () => {
    const { activationKey, handleReveal } = this.props
    const externalUrl = `https://redeem.microsoft.com/?mstoken=${activationKey}`
    handleReveal(partnerId)
    return window.open(externalUrl)
  }

  render() {
    return (
      <div className="mb-3">
        <div className="row">
          <div className="col">
            <Button
              color="dark"
              block
              outline
              onClick={this.handleRedeemWithBrowser}
              aria-label="Activate product on Microsoft website (opens in new window)"
            >
              <FormattedMessage id="microsoft.button.activate" />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

MicrosoftIntegration.propTypes = {
  activationKey: PropTypes.string.isRequired,
  handleReveal: PropTypes.func.isRequired,
}
